var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_868_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H18C8.05887 0 0 8.05887 0 18V72C0 81.9411 8.05887 90 18 90H72C81.9411 90 90 81.9411 90 72V18C90 8.05887 81.9411 0 72 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25 72.1064C41.356 72.1064 45.5 67.9918 45.5 62.922V53.7376H36.25C31.144 53.7376 27 57.8522 27 62.922C27 67.9918 31.144 72.1064 36.25 72.1064Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 44.5532C27 39.4834 31.144 35.3688 36.25 35.3688H45.5V53.7376H36.25C31.144 53.7376 27 49.623 27 44.5532Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26.1844C27 21.1146 31.144 17 36.25 17H45.5V35.3688H36.25C31.144 35.3688 27 31.2542 27 26.1844Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 17H54.75C59.856 17 64 21.1146 64 26.1844C64 31.2542 59.856 35.3688 54.75 35.3688H45.5V17Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 44.5532C64 49.623 59.856 53.7376 54.75 53.7376C49.644 53.7376 45.5 49.623 45.5 44.5532C45.5 39.4834 49.644 35.3688 54.75 35.3688C59.856 35.3688 64 39.4834 64 44.5532Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_868_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob6);
export default __webpack_public_path__ + "static/media/blob6.7be89f63555b02d75a6b945285e66eb3.svg";
export { ForwardRef as ReactComponent };